import { render } from "./AuthenticationLayout.vue?vue&type=template&id=56b3ffd0&scoped=true"
import script from "./AuthenticationLayout.vue?vue&type=script&lang=js"
export * from "./AuthenticationLayout.vue?vue&type=script&lang=js"

import "./AuthenticationLayout.vue?vue&type=style&index=0&id=56b3ffd0&scoped=true&lang=css"

import exportComponent from "/home/forge/newsletter.norden.org/releases/74710130/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b3ffd0"]])

export default __exports__